import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';

import { createRouter, createWebHistory } from 'vue-router';
import { basicRoutes } from './routes';

// 白名单应该包含基本静态路由
const WHITE_NAME_LIST: string[] = [];
const getRouteNames = (array: any[]) =>
  array.forEach((item) => {
    WHITE_NAME_LIST.push(item.name);
    getRouteNames(item.children || []);
  });
getRouteNames(basicRoutes);

// app router
export const history = createWebHistory(import.meta.env.VITE_PUBLIC_PATH);

// 创建一个可以被 Vue 应用程序使用的路由实例
export const router = createRouter({
  // 创建一个 hash 历史记录。
  history,
  // 应该添加到路由的初始路由列表。
  routes: basicRoutes as unknown as RouteRecordRaw[],
  // 是否应该禁止尾部斜杠。默认为假
  strict: true,
  scrollBehavior(to, _, savedPosition) {
    // 检查路由是否含有锚点
    if (to.hash) {
      setTimeout(() => {
        // 选取对应的锚点元素
        const anchor = document.querySelector(`a[href="${to.hash}"]`);
        if (anchor) {
          // 将页面滚动到锚点位置
          document.body.scrollTo({
            top: anchor?.offsetTop || 0,
            behavior: 'smooth',
          });
        }
      }, 500);

      return {
        left: 0,
        top: 0,
      };
    }

    if (to.meta?.scrollToTop) {
      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return { left: 0, top: 0 };
    }

    // 没有锚点时，返回上次滚动位置或者顶部
    return savedPosition || { left: 0, top: 0 };
  },
});

// reset router
export function resetRouter() {
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (name && !WHITE_NAME_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
}

// config router
// 配置路由器
export function setupRouter(app: App<Element>) {
  app.use(router);
}
